import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';

@Directive({
  selector: '[appDropdownItemColors]',
  standalone: true
})
export class DropdownItemColorDirective implements AfterViewInit, OnDestroy {
  @Input('appDropdownItemColors') itemColors: Record<string, string> = {};

  private observer?: MutationObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    this.applyClassesAndStyles();

    this.observer = new MutationObserver(() => this.applyClassesAndStyles());
    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private applyClassesAndStyles() {
    const dropdownItems = this.el.nativeElement.querySelectorAll('.multiselect-item-checkbox');

    dropdownItems.forEach((li: Element) => {
      const textDiv = li.querySelector('div');
      const text = textDiv?.textContent?.trim();
      if (text) {
        for (const [searchText, color] of Object.entries(this.itemColors)) {
          if (text === searchText || text.toLowerCase() === searchText.toLowerCase()) {
            li.setAttribute('style', `--custom-dropdown-item-color: ${color}`);
            if (!li.classList.contains('custom-color')) {
              li.classList.add('custom-color');
            }
          }
        }
      }
    });

    const selectedItems = this.el.nativeElement.querySelectorAll('.selected-item');
    selectedItems.forEach((item: Element) => {
      const textSpan = item.querySelector('span');
      const text = textSpan?.textContent?.trim().replace(/\u00a0/g, ''); // Remove &nbsp;
      if (text) {
        for (const [searchText, color] of Object.entries(this.itemColors)) {
          if (text === searchText || text.toLowerCase() === searchText.toLowerCase()) {
            item.setAttribute('style', `--custom-dropdown-item-color: ${color}`);
            if (!item.classList.contains('custom-color')) {
              item.classList.add('custom-color');
            }
          }
        }
      }
    });
  }
}
